/** User JWT key in localStorage (persists across browser close). */
export const USER_TOKEN_KEY = "rl_user_token";
export const USER_PROFILE_KEY = "rl_user_profile";

export function isUnauthorizedStatus(status) {
  return status === 401;
}

export function getStoredUserToken() {
  try {
    return localStorage.getItem(USER_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function storeUserToken(token) {
  localStorage.setItem(USER_TOKEN_KEY, token);
}

export function clearUserToken() {
  localStorage.removeItem(USER_TOKEN_KEY);
  try {
    localStorage.removeItem(USER_PROFILE_KEY);
  } catch {
    /* ignore */
  }
}

export function storeUserProfile(user) {
  try {
    localStorage.setItem(USER_PROFILE_KEY, JSON.stringify(user));
  } catch {
    /* ignore */
  }
}

export function getStoredUserProfile() {
  try {
    const raw = localStorage.getItem(USER_PROFILE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** True when an axios/fetch-style error is an auth rejection we must force-login for. */
export function isUnauthorizedError(err) {
  return isUnauthorizedStatus(err?.response?.status ?? err?.status);
}

let _sessionClearHandler = null;

/** AuthProvider registers here so the axios 401 interceptor can clear React state too. */
export function registerSessionClearHandler(handler) {
  _sessionClearHandler = handler;
  return () => {
    if (_sessionClearHandler === handler) _sessionClearHandler = null;
  };
}

export function clearSessionFromInterceptor() {
  clearUserToken();
  if (typeof _sessionClearHandler === "function") {
    _sessionClearHandler();
  }
}
